<template>
  <o-section
    :title="label || schema.verbose_name"
    not-closable
    :level="level + 1"
    body-classes="p-0"
  >
    <o-item-editable-table
      v-model="items"
      :default-new-value="newChild"
      :form-state="formState"
      :item-name="schema.verbose_name"
      @change="changed"
    >
      <template slot="o-headers">
        <th v-if="canSee(schema, 'user')">{{ schema.fields.user.label }}</th>
        <th v-if="canSee(schema, 'read')">{{ schema.fields.read.label }}</th>
        <th v-if="canSee(schema, 'hide')">{{ schema.fields.hide.label }}</th>
        <th v-if="canSee(schema, 'button_selected')">
          {{ schema.fields.button_selected.label }}
        </th>
        <th v-if="canSee(schema, 'email_after')">
          {{ schema.fields.email_after.label }}
        </th>
        <th v-if="canSee(schema, 'sms_after')">
          {{ schema.fields.sms_after.label }}
        </th>
        <th v-if="canSee(schema, 'created_date')">
          {{ schema.fields.created_date.label }}
        </th>
        <th v-if="canSee(schema, 'modified_date')">
          {{ schema.fields.modified_date.label }}
        </th>
      </template>
      <template #o-body="{ item, index }">
        <td v-if="canSee(schema, 'user')">
          <o-widget-wrapper
            :schema="schema"
            name="user"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-select
              flat
              clearable
              nolabel
              v-model="items[index].user"
              :items="optionUserItems"
              text-field="username"
              value-field="id"
              :validator="validators.$each[index][schema.fields.user.name]"
              :loading="optionUserWorking"
              name="user"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              v-bind="schema.fields.user"
              :form-state="formState"
            ></o-select>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'read')">
          <date-display :value="items[index].read" />
        </td>
        <td v-if="canSee(schema, 'hide')" class="text-center">
          <o-widget-wrapper
            :schema="schema"
            name="hide"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-checkbox
              v-model="items[index].hide"
              :form-state="formState"
              name="hide"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.hide"
            ></o-checkbox>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'button_selected')">
          {{ getButton(items[index].button_selected) }}
        </td>
        <td v-if="canSee(schema, 'email_after')" class="text-center">
          <o-widget-wrapper
            :schema="schema"
            name="email_after"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-date-time
              v-model="items[index].email_after"
              :form-state="formState"
              name="email_after"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.email_after"
            ></o-date-time>
            <div
              class="badge badge-pill badge-secondary"
              v-if="items[index].email_sent_id"
            >
              Sent
            </div>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'sms_after')" class="text-center">
          <o-widget-wrapper
            :schema="schema"
            name="sms_after"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-date-time
              v-model="items[index].sms_after"
              :form-state="formState"
              name="sms_after"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.sms_after"
            ></o-date-time>
            <div
              class="badge badge-pill badge-secondary"
              v-if="items[index].sms_sent_id"
            >
              Sent
            </div>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'created_date')">
          <date-display :value="items[index].created_date" />
        </td>
        <td v-if="canSee(schema, 'modified_date')">
          <date-display :value="items[index].modified_date" />
        </td>
      </template>
    </o-item-editable-table>
  </o-section>
</template>
<script>
import _ from "lodash";
import schema from "../../schema/index.js";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify.js";
import { CreateDefaultItem } from "../../../vue-ocom/schema/schema_utils.js";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
} from "../../../vue-ocom/mixins";
import OItemEditableTable from "../../../vue-ocom/components/table/OItemEditableTable.vue";
import OSection from "../../../vue-ocom/components/layout/OSection.vue";

export default {
  name: "NotificationStatusFormTable",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("NotificationStatus"),
    CreateCodeTableFetchMixin(["User"]),
  ],
  components: { OItemEditableTable, OSection },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
    buttons: { type: Array, default: () => [] },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.NotificationStatus,
        {}
      ) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.NotificationStatus),
    };
  },
  methods: {
    getButton(index) {
      var result = this.buttonsByID[index];

      if (!result) {
        return "";
      }
      return result.button_text;
    },
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
  },
  computed: {
    buttonsByID() {
      return _.keyBy(this.buttons, "id");
    },
  },
  created() {
    // this.loadCodeTables()
  },
};
</script>
